import { Controller } from "@hotwired/stimulus"

/**
 * Simple toggle between a poster image and a video player.
 * Click poster -> show video and play. Video ends -> show poster again.
 */
export default class extends Controller {
  static targets = ["poster", "player"]

  play() {
    this.posterTarget.classList.add("hidden")
    this.playerTarget.classList.remove("hidden")
    this.playerTarget.play()
  }

  reset() {
    this.playerTarget.classList.add("hidden")
    this.playerTarget.currentTime = 0
    this.posterTarget.classList.remove("hidden")
  }
}
